module.exports = __webpack_public_path__ + "static/media/darktheme.06507e4a.png";